module.exports = __webpack_public_path__ + "static/image/service/pc/ceo@3x.jpg?4b5f34bc";